import { useFormState } from 'react-use-form-state';
import { useToasts } from 'react-toast-notifications';
import { useMutation } from '@apollo/react-hooks';
import { useHistory } from 'react-router';

import { CHANGE_PASSWORD_WITH_TOKEN } from './queries';
import { routes } from '../../constants';

const _v = {
  newPassword: 'newPassword',
  confirmPassword: 'confirmPassword',
};

const useChangePassword = ({ token } = {}) => {
  const history = useHistory();

  if (!token) history.push(routes.home.pathname);

  const [formState, form] = useFormState({
    [_v.newPassword]: '',
    [_v.confirmPassword]: '',
  });
  const { addToast } = useToasts();

  const [runMutation, { loading }] = useMutation(CHANGE_PASSWORD_WITH_TOKEN, {
    onCompleted: () => {
      formState.reset();
      const time = 4000;
      addToast('Your Password has Been updated successfully', {
        appearance: 'success',
        autoDismiss: true,
        autoDismissTimeout: time,
      });
      setTimeout(() => history.push(routes.login.pathname), time);
    },
    onError: (err) => {
      console.log(err);
      if (err.graphQLErrors) {
        err.graphQLErrors.forEach((e) => {
          addToast(e.message, {
            appearance: 'error',
            autoDismiss: true,
          });
        });
      } else {
        addToast('Something unexpected happened', {
          appearance: 'error',
          autoDismiss: true,
        });
      }
    },
  });

  const handleSubmit = (e) => {
    e.preventDefault();

    // TODO: validation
    if (formState.values[_v.newPassword] !== formState.values[_v.confirmPassword]) {
      addToast('Passwords do not match', {
        appearance: 'error',
        autoDismiss: true,
        autoDismissTimeout: 10000,
      });
      formState.setFieldError(_v.confirmPassword, 'Passwords do not match');
      return;
    }

    runMutation({ variables: { token, password: formState.values[_v.newPassword] } });
  };

  return {
    _v,
    form,
    formState,
    handleSubmit,
    loading,
  };
};

export default useChangePassword;
